import type { FaireProductEntity } from "../../entity_types/product";

export const p_avckg9gzh5: FaireProductEntity = {
  token: "p_avckg9gzh5",
  type: "product",
  name: "8 MM ENERGY BEAD BRACELETS",
  brandToken: "b_7a21757f",
  brandName: "Benjamin International",
  imageUrl: "https://cdn.faire.com/fastly/c8080fbd3cda1881f05d917540bb680e4bca8a41834ff4b6d0abb86ad2e94904.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8eecace6aeb9f703d9ca5894d3277f0993e36f1903ca025134b842ea71b1c682.jpeg",
    "https://cdn.faire.com/fastly/0ff39f2deb3ac66466ad964265755a9c8814b067ebaa8233f8e567da031ab610.jpeg",
    "https://cdn.faire.com/fastly/b53fcfce7b6480d641d709befe130be486ac830fa74d68ba32de2c07e5e0b4b2.jpeg",
    "https://cdn.faire.com/fastly/63e0e36d51328cebac035e5958d14388f0743e842b0f782d6d9b5fc9571d769c.jpeg",
    "https://cdn.faire.com/fastly/2156933923bf5cc0bbc0696248904f9c91bf4d2f1fd5f09665e14a0a1ed7fdab.jpeg",
    "https://cdn.faire.com/fastly/c6671332b7e4b12f6c90dd5bde1f083b30c0028c4458fc06ed834a7f56ac766b.jpeg",
    "https://cdn.faire.com/fastly/542dae1137f9892ea7d2ba64af48aa4865aeaf0be615c7cfa4bd843a4f959b8a.jpeg",
    "https://cdn.faire.com/fastly/6991b6d2a9d8e68db426d3340e1f885c5ff79692806097d92cfddd7e56595310.jpeg",
    "https://cdn.faire.com/fastly/d87330d31ee3ed75d8dd5347c83c9981c3245ce0fe4088d5bcdb0cf8eb521e4f.jpeg",
    "https://cdn.faire.com/fastly/dee502d47fb9bc3550967d2d0361aa41f48513ea6620ca51157854430201e50a.jpeg",
    "https://cdn.faire.com/fastly/9c102f28bb16f43c37ddf0a1fca8d21c3e58a5f2eabd221626a1ee7b37653636.jpeg",
    "https://cdn.faire.com/fastly/96f6ba7964fb5819c25a3f2301b155d98fae7b9f66ff85228235a601f807daed.jpeg",
    "https://cdn.faire.com/fastly/84ef65a8e0835b08d629e213de2d1810c793bdbaa0af3ef896a23e1f31a37808.jpeg",
    "https://cdn.faire.com/fastly/395e117f56025481f1bdce72e110a77e5f35faa731f0a7aed31f3785ba267353.jpeg",
    "https://cdn.faire.com/fastly/e1aa1fefc79ead0b372b8cd675778410971e27aa8b0a56c8ead8d6a96725279f.jpeg",
    "https://cdn.faire.com/fastly/d387ad6bffd68e56cfcb4f8a530250e0866591a42cbaff079375dc6d29ea0342.jpeg"
  ],
  priceDollars: 2,
  description: "Discover the power of our 8mm Crystal Gemstone Energy Bead Stretch Bracelets.\n\nBenjamin International, a trusted name in product design and manufacturing, brings you these unique spiritual stone/crystal accessories.\n\nEach bracelet is meticulously crafted, combining global inspiration and local manufacturing.\n\nOur artisans draw inspiration from their travels, applying innovative ideas and design motifs to each piece.\n\nOur products, both American-made and imported from exotic places like Nepal, Indonesia, and India, are chosen for their ethical and meaningful nature.\n\nEach traditional craft or product, like our energy bead stretch bracelets, carries its own special nuance and beauty.\n\nEmbrace the spiritual energy and artisan craftsmanship with Benjamin International.",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:35.945Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
